import { combineReducers } from '@reduxjs/toolkit'

import attendanceReducer from './attendance'
import attendanceDailyReducer from './attendance-daily'
import attendancePeriodReducer from './attendance-period'
import attendanceReportReducer from './attendance-report'
import finalGradeSessionReducer from './final-grades'
import gradingPolicyReducer from './grading-policy'
import schduleReducer from './schedule'
import courseSessionEnrollmentReducer from './course-session-enrollment'
import attendanceSettingsReducer from './attendance-settings'

const combinedReducer = combineReducers({
  attendance: attendanceReducer,
  attendanceDaily: attendanceDailyReducer,
  attendancePeriod: attendancePeriodReducer,
  attendanceReport: attendanceReportReducer,
  finalGrades: finalGradeSessionReducer,
  gradingPolicy: gradingPolicyReducer,
  schedule: schduleReducer,
  courseSessionEnrollment: courseSessionEnrollmentReducer,
  attendanceSettings: attendanceSettingsReducer,

})

export default combinedReducer
